import Switch from '@/components/Switch/Switch';
import TextField from '@/components/TextField/TextField';
import theme from '@/theme';
import styled from '@emotion/styled';
import { useController, useFormContext } from 'react-hook-form';
import { ColorsField } from './ColorsField';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;
const Title = styled.span`
    color: ${({ theme }) => theme.colors.secondary.main};
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
`;

const ToggleContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 8px;
    border-radius: 8px;
    background-color: ${theme.colors.black[50]};
`;

const StyledTextField = styled(TextField)`
    & .MuiInputBase-root {
        border-radius: 6px;
    }
`;

export const CtaFields = () => {
    const {
        register,
        control,
        formState: { errors },
    } = useFormContext();

    const { field: ctaEnabledField } = useController({
        name: 'cta_enabled',
        control,
    });

    return (
        <Container>
            <ToggleContainer>
                <Title id="campaign-cta-enabled">Add call to action</Title>
                <Switch
                    checked={ctaEnabledField.value}
                    onChange={ctaEnabledField.onChange}
                    onBlur={ctaEnabledField.onBlur}
                    inputRef={ctaEnabledField.ref}
                />
            </ToggleContainer>

            {ctaEnabledField.value && (
                <>
                    <Title id="campaign-cta-label">Label</Title>
                    <StyledTextField
                        size="small"
                        placeholder="Enter your label here"
                        error={!!errors.cta_text}
                        inputProps={{
                            ...register('cta_text', {
                                setValueAs: value => value.trim() || undefined,
                            }),
                            'data-hj-allow': '',
                        }}
                    />
                    <Title id="campaign-cta-url">URL</Title>
                    <StyledTextField
                        size="small"
                        placeholder="Enter your URL here"
                        error={!!errors.cta_url}
                        inputProps={{
                            ...register('cta_url', {
                                setValueAs: value => value.trim() || undefined,
                            }),
                            'data-hj-allow': '',
                        }}
                    />
                    <ColorsField />
                </>
            )}
        </Container>
    );
};
